export enum ButtonType {
  Button,
  LoadingButton,
}
